export default "__VITE_ASSET__BRGs2tKu__"